/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import router from '../router/index'
// import jscookie from 'js-cookie'
import Cookies from 'js-cookie'
import BaseUrl from '../assets/js/baseUrl'
axios.defaults.baseURL = `${BaseUrl}api`

// this.$jcookie.set()

// import { Loading } from 'element-ui'
// 超时时间
// axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

axios.interceptors.request.use(config => {
  const token = window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : ''
  if (token) {
      config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  router.push({path: '/NotFound'})
  return Promise.reject(error)
})
// axios.interceptors.request.use(config => {
//   const token = Cookies.get('token') ? Cookies.get('token') : ''
//   if (token) {
//       config.headers.Authorization = `Bearer ${token}`
//   }
//   return config
// }, error => {
//   router.push({path: '/NotFound'})
//   return Promise.reject(error)
// })
// http响应拦截器
axios.interceptors.response.use(data => { // 响应成功关闭loading
  // loadinginstace.close();
  return data
}, error => {
  // loadinginstace.close();
  if (error.response) {
    switch (error.response.status) {
      case 401:
        sessionStorage.removeItem('token')
        // Cookies.remove('token')
        router.replace({path: '/Login', query: {redirect: router.currentRoute.fullPath}})
        break
      case 403:
        router.push({path: '/NotFound'})
        break
      case 404:
        router.push({path: '/NotFound'})
        break
      case 500:
        router.push({path: '/NotFound'})
        break
      case 502:
        router.push({path: '/NotFound'})
        break
      case 503:
        router.push({path: '/NotFound'})
        break
    }
  } else {
    router.push({path: '/NotFound'})
  }
  return Promise.reject(error)
})
export default axios



// WEBPACK FOOTER //
// ./src/http/http.js